'use strict';

import VideoPlayTrigger from "../../../frontend/js/video-play-trigger";

class PageListVideoPlayer extends VideoPlayTrigger {
    constructor() {
        super({ triggerSelector: '.page-list-carousel-card--video', imageSelector: '.page-list-carousel-card__image' });
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new PageListVideoPlayer();
});